import axios from "axios";
import BaseAuth from "../module/BaseAuth";

class AuthService extends BaseAuth {
  async login(url, data) {
    try {
      const response = await this.postLogin("/auth/login" + url, "", data);
      window.isLoggingOut = false;
      return response;
    } catch (error) {
      // console.error("Error posting data:", error);
      // throw error;
    }
  }

  async validate(token) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_EMS}/auth/validate`,
        { headers: { Authorization: token } }
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return error.response.data;
      }
      return { status: 500, message: "Terjadi kesalahan koneksi" };
    }
  }
}

export default new AuthService();
